export enum ReportSector {
  ENERGY = 'Energy',
  TRANSPORT = 'Transport',
  INDUSTRIAL_PROCESSES = 'Industrial Processes and Product Use',
  AGRICULTURE = 'Agriculture',
  LULUCF = 'LULUCF',
  WASTE = 'Waste',
  OTHER = 'Other',
}
